import { render, staticRenderFns } from "./Homepage.vue?vue&type=template&id=3df9edc2&lang=pug"
import script from "./Homepage.vue?vue&type=script&lang=ts"
export * from "./Homepage.vue?vue&type=script&lang=ts"
import style0 from "./Homepage.vue?vue&type=style&index=0&id=3df9edc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports